import * as React from 'react';
// import once from 'lodash/once';

import { Preloader } from '@wix/wix-base-ui';

import { fetchFeed, reportEvent, getNotificationCount } from '../../actions';
import FeedHeader from '../FeedHeader';
import FeedFooter from '../FeedFooter';
import FeedError from '../FeedError';
import Card from '../Card';
import { biLogger } from '../../services/biLogger';
import { REPORT_EVENTS, BI_EVENTS } from '../../constants';

import { IAnnouncementItem } from '../../types';

import styles from './Feed.scss';

interface FeedProps {
  metaSiteInstance: string;
  metaSiteId: string;
  language?: string;
  subjectNames: string[];
  origin?: string;
  viewMode?: string;
  title?: string;
  description?: string;
  footerTitle?: string;
  footerLink?: string;
  automationId?: string;
  dataHook?: string;
  onOpen?(): void;
  onClose?(): void;
}

interface FeedState {
  isOpen: boolean;
  isLoading: boolean;
  hasError: boolean;
  notificationCount: number;
  cards: IAnnouncementItem[];
}

// cannot track icon show, notification show

class Feed extends React.Component<FeedProps, FeedState> {
  static displayName = 'Feed';
  static defaultProps = {
    viewMode: 'desktop',
    title: 'New Releases',
    footerTitle: 'You’re all caught up',
    footerLink: 'See All Updates',
    subjectNames: ['BusinessManager'],
    automationId: 'discovery-feed',
    dataHook: 'discovery-feed',
  };

  state: FeedState = {
    isOpen: false,
    isLoading: true,
    hasError: false,
    notificationCount: 0,
    cards: [],
  };

  async componentDidMount() {
    const notificationCount = await getNotificationCount({
      metaSiteInstance: this.props.metaSiteInstance,
      metaSiteId: this.props.metaSiteId,
      origin: this.props.origin,
      subjectNames: this.props.subjectNames,
      language: this.props.language,
    });

    this.setState({
      notificationCount,
    });

    this.setState({ isOpen: true });

    this.sendBI(BI_EVENTS.OPEN_FEED);

    await this.fetchData();
    await reportEvent({
      type: REPORT_EVENTS.SEEN,
      metaSiteInstance: this.props.metaSiteInstance,
      language: this.props.language,
    });

    if (this.props.onOpen) {
      this.props.onOpen();
    }

    // await reportEvent(REPORT_EVENTS.ICON_SHOWN, this.props.metaSiteInstance);
  }

  async fetchData() {
    try {
      const cards = await fetchFeed({
        metaSiteInstance: this.props.metaSiteInstance,
        subjectNames: this.props.subjectNames,
        language: this.props.language,
      });

      this.setState({
        cards,
        isLoading: false,
        hasError: false,
      });
    } catch (e) {
      this.setState({
        hasError: true,
        isLoading: false,
      });

      throw e;
    }
  }

  close = () => {
    this.setState({ isOpen: false });

    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onFetchClick = () => {
    this.setState({ isLoading: true });

    void this.fetchData();
  };

  sendBI = (eventId: string, params = null) => {
    const { origin, metaSiteId } = this.props;

    void biLogger.log({
      evid: eventId,
      msid: metaSiteId,
      platform: origin,
      ...params,
    });
  };

  render() {
    const { title, automationId, dataHook, footerTitle, footerLink } =
      this.props;
    const { cards, isLoading, hasError, notificationCount } = this.state;

    return (
      <div
        className={styles.container}
        data-aid={automationId}
        data-hook={dataHook}
      >
        <FeedHeader title={title} onClose={this.close} />
        <div className={styles.feed}>
          {hasError ? (
            <FeedError onFetchClick={this.onFetchClick} />
          ) : (
            <div className={styles.list}>
              {isLoading ? (
                <div className={styles.loading}>
                  <Preloader className="large" />
                </div>
              ) : (
                <>
                  {cards.map((card: IAnnouncementItem, index: number) => (
                    <Card
                      key={card.id}
                      position={index + 1}
                      sendBI={this.sendBI}
                      isNew={index < notificationCount}
                      {...card}
                    />
                  ))}

                  <FeedFooter
                    footerTitle={footerTitle}
                    footerLink={footerLink}
                    sendBI={this.sendBI}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Feed;
